import axios from 'axios'
import { envHttpUrl } from '../../http/globalMethod'

// 2026-10-20 coder(lq): 独立会话请求，不使用/持久化内部令牌；避免旧包装器吞掉真实HTTP错误。
const client = axios.create({ withCredentials: true, timeout: 10000 })
export async function menuAdminRequest(path, { method = 'GET', data, params = {}, csrfToken } = {}) {
    const baseUrl = envHttpUrl().baseUrl
    if (!baseUrl) throw new Error('当前环境没有配置管理接口地址')
    const response = await client.request({
        baseURL: `${window.location.protocol}${baseUrl}`,
        url: `/lechun-baseservice/menuApiAdmin/${path}`, method, data,
        params: { ...params, pageRouterUrl: '/admin/menuApiPermission' },
        headers: csrfToken ? { 'X-Menu-Admin-Csrf': csrfToken } : {},
    })
    if (response.data && response.data.status && response.data.status !== 200) {
        throw new Error(response.data.message || '原有网关权限未通过，请检查登录及管理菜单授权')
    }
    return response.data
}
export const errorMessage = error => (error.response && error.response.data && error.response.data.message)
    || error.message || '请求失败，请稍后重试'
